import React from 'react';
import { Grid } from '@tmap/mmm-style-guide/src/Grid';
import Question from './question';

function MoveDetailsFormBody(props) {
  const {
    stage,
    incentive,
    fieldConfigs = [],
  } = props;
  const fields = fieldConfigs.filter((fc) => fc.category === stage);
  return (
    <Grid container spacing={{ xs: 4, md: 2 }} alignItems='start'>
      {fields.map((f) => <Question field={f} data={{ incentive }} key={f.path} titleSpacing={f.type === 'slider' ? 'center' : 'medium'} />)}
    </Grid>
  );
}

export default MoveDetailsFormBody;
